import { useMutation } from "@tanstack/react-query";
import { createWhatsappCampaign } from "../api.ts";
import type { CreateCampaignFormData, WhatsappCampaign } from "../../types.ts";
import { success } from "@";

// Mutation hook for creating a WhatsApp campaign
export const useCreateWhatsappCampaignMutation = () => {
  return useMutation<WhatsappCampaign, Error, CreateCampaignFormData>({
    mutationFn: async (data: CreateCampaignFormData) => {
      const response = await createWhatsappCampaign(data);
      return response.data;
    },
    onSuccess: async () => {
      await success("تم إنشاء الحملة بنجاح");
      window.location.reload();
    },
  });
};
